import useCreateCronExpression, {CronDayTimeProps, CronDefineDayProps} from "./Hook/useCreateCronExpression";
import React, {useEffect, useState} from "react";
import {Checkbox, Modal, Radio, RadioChangeEvent, Select} from 'antd';
import {CheckboxChangeEvent} from "antd/es/checkbox";

export interface CronMakerProps
{
    setCronExpression:(value:string)=>void,
    revCronExpressionText:string,
    setCronExpressionText:(value:string)=>void,

}
function CronMaker(props : CronMakerProps)
{
    const {setCronExpression, revCronExpressionText, setCronExpressionText} = props;


    const [everyDayStartHour, setEveryDayStartHour] = useState<number>(0);
    const [everyDayEndHour, setEveryDayEndHour] = useState<number>(23);

    const [everyDayStartHour2, setEveryDayStartHour2] = useState<number>(0);
    const [everyDayEndHour2, setEveryDayEndHour2] = useState<number>(23);

    const [everyMin, setEveryMin] = useState<number>(10);
    const [everyHour, setEveryHour] = useState<number>(1);


    const [everyDayHour, setEveryDayHour] = useState<number>(0);
    const [everyDayMin, setEveryDayMin] = useState<number>(0);

    const [weekDayHour, setWeekDayHour] = useState<number>(0);
    const [weekDayMin, setWeekDayMin] = useState<number>(0);

    const [weekEndHour, setWeekEndHour] = useState<number>(0);
    const [weekEndMin, setWeekEndMin] = useState<number>(0);

    const [monDay, setMonDay] = useState<boolean>(false);
    const [tuesDay, setTuesDay] = useState<boolean>(false);
    const [wednesDay, setWednesDay] = useState<boolean>(false);
    const [thursday, setThursday] = useState<boolean>(false);
    const [friday, setFriday] = useState<boolean>(false);
    const [saturday, setSaturday] = useState<boolean>(false);
    const [sunday, setSunday] = useState<boolean>(false);

    const [defineDayHour, setDefineDayHour] = useState<number>(0);
    const [defineDayMin, setDefineDayMin] = useState<number>(0);



    const [menuStr, setMenuStr] = useState<string>( "EveryMin" );
    const {cronExpression, cronExpressionText
        , createCronEveryMinExpression
        , createCronEveryHourExpression
        , createCronEveryDayExpression
        , createCronEveryWeekDayExpression
        , createCronEveryWeekEndExpression
        , createCronDefineDayExpression
        , initExpression
    } = useCreateCronExpression();


    const everyDayStartHourChange = (value: number) => {
        setEveryDayStartHour(value);
    };



    const everyDayEndHourChange = (value: number) => {
        setEveryDayEndHour(value);
    };

    const everyDayStartHourChange2 = (value: number) => {
        setEveryDayStartHour2(value);
    };

    const everyDayEndHourChange2 = (value: number) => {
        setEveryDayEndHour2(value);
    };

    const everyDayHourChange = (value: number) => {
        setEveryDayHour(value);
    };




    const everyDayMinChange = (value: number) => {
        setEveryDayMin(value);
    };

    const everyDayTimeChange = () =>
    {
        const defineTime:CronDayTimeProps = {
            hour:everyDayHour,
            minute:everyDayMin,
        }
        createCronEveryDayExpression(defineTime);
    }

    const weekDayHourChange = (value: number) => {
        setWeekDayHour(value);
    };

    const weekDayMinChange = (value: number) => {
        setWeekDayMin(value);
    };

    const weekDayTimeChange = () =>
    {
        const defineTime:CronDayTimeProps = {
            hour:weekDayHour,
            minute:weekDayMin,
        }
        createCronEveryWeekDayExpression(defineTime);
    }


    const defineDayHourChange = (value: number) => {
        setDefineDayHour(value);
    };

    const defineDayMinChange = (value: number) => {
        setDefineDayMin(value);
    };

    const defineDayChange = () =>
    {
        const defineTime:CronDayTimeProps = {
            hour:defineDayHour,
            minute:defineDayMin,
        }

        const defineDayParam:CronDefineDayProps ={
            monDay : monDay,
            tuesDay : tuesDay,
            wednesDay : wednesDay,
            thursday : thursday,
            friday : friday,
            saturday : saturday,
            sunday : sunday,
            cronDayTime : defineTime,
        }
        createCronDefineDayExpression(defineDayParam);
    }

    const everyMinChange = (value: number) => {
        setEveryMin(value);
    };

   /* const everyMinApply = () =>
    {
        createCronEveryMinExpression(everyMin);
    }
    */

    const everyHourChange = (value: number) => {
        setEveryHour(value);
    };

    /*
    const everyHourApply = () =>
    {
        createCronEveryHourExpression(everyHour);
    }
     */

    const onChangeMonday = (e: CheckboxChangeEvent) => {
        setMonDay(e.target.checked);
    };

    const onChangeTuesday = (e: CheckboxChangeEvent) => {
        setTuesDay(e.target.checked);
    };

    const onChangeWednesday = (e: CheckboxChangeEvent) => {
        setWednesDay(e.target.checked);
    };

    const onChangeThursday = (e: CheckboxChangeEvent) => {
        setThursday(e.target.checked);
    };

    const onChangeFriday = (e: CheckboxChangeEvent) => {
        setFriday(e.target.checked);
    };

    const onChangeSaturday = (e: CheckboxChangeEvent) => {
        setSaturday(e.target.checked);
    };

    const onChangeSunDay = (e: CheckboxChangeEvent) => {
        setSunday(e.target.checked);
    };


    const weekEndHourChange = (value: number) => {
        setWeekEndHour(value);
    };

    const weekEndMinChange = (value: number) => {
        setWeekEndMin(value);
    };

    const weekEndTimeChange = () =>
    {
        const defineTime:CronDayTimeProps = {
            hour:weekEndHour,
            minute:weekEndMin,
        }
        createCronEveryWeekEndExpression(defineTime);
    }
    const onChangeMenu = (e: RadioChangeEvent) => {
        setMenuStr(e.target.value);
    };


    useEffect(() => {
        if (menuStr === "EveryMin" )
        {
            if (everyDayStartHour > everyDayEndHour)
            {
                Modal.error({
                    title: "시간설정오류",
                    content: '시간설정이 올바르지 않습니다. 시작시간과 끝시간을 확인해주세요.',
                });
            }
            else
            {
                createCronEveryMinExpression(everyDayStartHour, everyDayEndHour, everyMin);
            }

        }

    }, [ everyDayStartHour,  everyDayEndHour, everyMin, menuStr]);

    useEffect(() => {
        if (menuStr === "EveryHour" )
        {
            if (everyDayStartHour2 > everyDayEndHour2)
            {
                Modal.error({
                    title: "시간설정오류",
                    content: '시간설정이 올바르지 않습니다. 시작시간과 끝시간을 확인해주세요.',
                });
            }
            else if (everyDayStartHour2 === everyDayEndHour2)
            {
                Modal.error({
                    title: "시간설정오류",
                    content: '시간설정이 올바르지 않습니다. 시작시간과 끝시간을 같을 수 없습니다.',
                });
            }
            else
            {
                createCronEveryHourExpression(everyDayStartHour2, everyDayEndHour2, everyHour);
            }

        }
    }, [  everyDayStartHour,  everyDayEndHour, everyHour, menuStr]);

    useEffect(() => {
        if (menuStr === "EveryDay" )
        {
            const defineTime:CronDayTimeProps = {
                hour:everyDayHour,
                minute:everyDayMin,
            }
            createCronEveryDayExpression(defineTime);
        }

    }, [ everyDayHour, everyDayMin, menuStr]);

    useEffect(() => {
        if (menuStr === "WeekDay" )
        {
            const defineTime:CronDayTimeProps = {
                hour:weekDayHour,
                minute:weekDayMin,
            }
            createCronEveryWeekDayExpression(defineTime);
        }

    }, [ weekDayHour, weekDayMin, menuStr]);

    useEffect(() => {
        if (menuStr === "WeekEnd" )
        {
            const defineTime:CronDayTimeProps = {
                hour:weekEndHour,
                minute:weekEndMin,
            }
            createCronEveryWeekEndExpression(defineTime);
        }

    }, [ weekEndHour, weekEndMin, menuStr]);

    useEffect(() => {

        if (menuStr === "DefineDay" )
        {
            const defineTime:CronDayTimeProps = {
                hour:defineDayHour,
                minute:defineDayMin,
            }

            const defineDayParam:CronDefineDayProps ={
                monDay : monDay,
                tuesDay : tuesDay,
                wednesDay : wednesDay,
                thursday : thursday,
                friday : friday,
                saturday : saturday,
                sunday : sunday,
                cronDayTime : defineTime,
            }
            createCronDefineDayExpression(defineDayParam);
        }
    }, [ defineDayHour, defineDayMin, monDay, tuesDay, wednesDay, thursday, friday, saturday, sunday, menuStr]);





    useEffect(() => {
        setCronExpression(cronExpression);
    }, [ cronExpression]);

    useEffect(() => {
        setCronExpressionText(cronExpressionText);
    }, [ cronExpressionText]);

    useEffect(() => {
        if (revCronExpressionText && revCronExpressionText.length > 0)
        {
            setMonDay(false);
            setTuesDay(false);
            setWednesDay(false);
            setThursday(false);
            setFriday(false);
            setSaturday(false);
            setSunday(false);

            if (revCronExpressionText.includes("분 마다") || revCronExpressionText.includes("분마다"))
            {
                if (revCronExpressionText.includes("매일"))
                {
                    if (revCronExpressionText.includes("시까지"))
                    {
                        // 정규식을 사용하여 숫자만 추출
                        const numbers:RegExpMatchArray|null = revCronExpressionText.match(/\d+/g);

                        // 각 숫자를 변수에 할당
                        if (numbers && numbers.length == 3)
                        {
                            const startHour = parseInt(numbers[0], 10);  // 8
                            const endHour = parseInt(numbers[1], 10);    // 19
                            const intervalMin = parseInt(numbers[2], 10); // 1

                            //setEveryHour( parseInt( revCronExpressionText.substring(0, revCronExpressionText.indexOf('시')) )  );
                            setEveryDayStartHour(startHour);
                            setEveryDayEndHour(endHour);
                            setEveryHour( intervalMin  );
                            setEveryMin( intervalMin);
                            setMenuStr('EveryMin');
                        }
                    }
                    else
                    {
                        const hour = revCronExpressionText.substring( revCronExpressionText.indexOf('시')-2);
                        const min = revCronExpressionText.substring( revCronExpressionText.indexOf('분')-2);
                        setEveryDayHour( parseInt(hour));
                        setEveryDayMin( parseInt(min) );
                        setMenuStr('EveryDay');
                    }

                }
                else if (revCronExpressionText.includes("평일"))
                {
                    const hour = revCronExpressionText.substring( revCronExpressionText.indexOf('시')-2);
                    const min = revCronExpressionText.substring( revCronExpressionText.indexOf('분')-2);
                    setWeekDayHour( parseInt(hour));
                    setWeekDayMin( parseInt(min) );
                    setMenuStr('WeekDay');
                }
                else if (revCronExpressionText.includes("주말"))
                {
                    const hour = revCronExpressionText.substring( revCronExpressionText.indexOf('시')-2);
                    const min = revCronExpressionText.substring( revCronExpressionText.indexOf('분')-2);
                    setWeekEndHour( parseInt(hour));
                    setWeekEndMin( parseInt(min) );
                    setMenuStr('WeekEnd');
                }
                else if (revCronExpressionText.includes("요일"))
                {
                    const hour = revCronExpressionText.substring( revCronExpressionText.indexOf('시')-2);
                    const min = revCronExpressionText.substring( revCronExpressionText.indexOf('분')-2);
                    setDefineDayHour( parseInt(hour));
                    setDefineDayMin( parseInt(min) );

                    if (revCronExpressionText.includes("월")) setMonDay(true);
                    if (revCronExpressionText.includes("화")) setTuesDay(true);
                    if (revCronExpressionText.includes("수")) setWednesDay(true);
                    if (revCronExpressionText.includes("목")) setThursday(true);
                    if (revCronExpressionText.includes("금")) setFriday(true);
                    if (revCronExpressionText.includes("토")) setSaturday(true);
                    if (revCronExpressionText.includes("일요일")) setSunday(true);
                    setMenuStr('DefineDay');
                }
               /* else
                {
                    setEveryMin( parseInt( revCronExpressionText.substring(0,2) )  );
                    setMenuStr('EveryMin');
                }

                */
            }
            else if (revCronExpressionText.includes("시간 마다"))
            {
                // 정규식을 사용하여 숫자만 추출
                const numbers:RegExpMatchArray|null = revCronExpressionText.match(/\d+/g);

                // 각 숫자를 변수에 할당
                if (numbers && numbers.length == 3)
                {
                    const startHour = parseInt(numbers[0], 10);  // 8
                    const endHour = parseInt(numbers[1], 10);    // 19
                    const intervalHour = parseInt(numbers[2], 10); // 1

                    //setEveryHour( parseInt( revCronExpressionText.substring(0, revCronExpressionText.indexOf('시')) )  );
                    setEveryDayStartHour2(startHour);
                    setEveryDayEndHour2(endHour);
                    setEveryHour( intervalHour  );
                    setMenuStr('EveryHour');
                }

            }
        }

    }, [revCronExpressionText]);





    return (
        <div style={{margin:"10px", width:"98%"}}>
            <div style={{marginBottom:"10px"}}>
            <Radio.Group onChange={onChangeMenu} value={menuStr} defaultValue={menuStr}>
                <Radio.Button value="EveryMin">매분</Radio.Button>
                <Radio.Button value="EveryHour">매시간</Radio.Button>
                <Radio.Button value="EveryDay">매일</Radio.Button>
                <Radio.Button value="WeekDay">평일</Radio.Button>
                <Radio.Button value="WeekEnd">주말</Radio.Button>
                <Radio.Button value="DefineDay">요일지정</Radio.Button>
            </Radio.Group>
            </div>
        { menuStr === "EveryMin" &&
            <div>
                매일 <Select
                defaultValue={everyDayStartHour}
                style={{ width: 60 }}
                onChange={everyDayStartHourChange}
                options={[
                    { value: 0, label: '00' },
                    { value: 1, label: '01' },
                    { value: 2, label: '02' },
                    { value: 3, label: '03' },
                    { value: 4, label: '04' },
                    { value: 5, label: '05' },
                    { value: 6, label: '06' },
                    { value: 7, label: '07' },
                    { value: 8, label: '08' },
                    { value: 9, label: '09' },
                    { value: 10, label: '10' },
                    { value: 11, label: '11' },
                    { value: 12, label: '12' },
                    { value: 13, label: '13' },
                    { value: 14, label: '14' },
                    { value: 15, label: '15' },
                    { value: 16, label: '16' },
                    { value: 17, label: '17' },
                    { value: 18, label: '18' },
                    { value: 19, label: '19' },
                    { value: 20, label: '20' },
                    { value: 21, label: '21' },
                    { value: 22, label: '22' },
                    { value: 23, label: '23' },
                ]}
            />시 ~
                <Select
                defaultValue={everyDayEndHour}
                style={{ width: 60 }}
                onChange={everyDayEndHourChange}
                options={[
                    { value: 0, label: '00' },
                    { value: 1, label: '01' },
                    { value: 2, label: '02' },
                    { value: 3, label: '03' },
                    { value: 4, label: '04' },
                    { value: 5, label: '05' },
                    { value: 6, label: '06' },
                    { value: 7, label: '07' },
                    { value: 8, label: '08' },
                    { value: 9, label: '09' },
                    { value: 10, label: '10' },
                    { value: 11, label: '11' },
                    { value: 12, label: '12' },
                    { value: 13, label: '13' },
                    { value: 14, label: '14' },
                    { value: 15, label: '15' },
                    { value: 16, label: '16' },
                    { value: 17, label: '17' },
                    { value: 18, label: '18' },
                    { value: 19, label: '19' },
                    { value: 20, label: '20' },
                    { value: 21, label: '21' },
                    { value: 22, label: '22' },
                    { value: 23, label: '23' },
                ]}
            />시 까지<br/>
                <Select
                    defaultValue={everyMin}
                    value={everyMin}
                    style={{ width: 60, marginTop:"5px" }}
                    onChange={everyMinChange}
                    options={[
                        { value: 1, label: '1' },
                        { value: 2, label: '2' },
                        { value: 3, label: '3' },
                        { value: 4, label: '4' },
                        { value: 5, label: '5' },
                        { value: 6, label: '6' },
                        { value: 7, label: '7' },
                        { value: 8, label: '8' },
                        { value: 9, label: '9' },
                        { value: 10, label: '10' },
                        { value: 15, label: '15' },
                        { value: 20, label: '20' },
                        { value: 25, label: '25' },
                        { value: 30, label: '30' },
                    ]}
                />분 마다 실행
            </div>
        }
        {
            menuStr === "EveryHour" &&
            <div>
                매일 <Select
                defaultValue={everyDayStartHour2}
                style={{ width: 60 }}
                onChange={everyDayStartHourChange2}
                options={[
                    { value: 0, label: '00' },
                    { value: 1, label: '01' },
                    { value: 2, label: '02' },
                    { value: 3, label: '03' },
                    { value: 4, label: '04' },
                    { value: 5, label: '05' },
                    { value: 6, label: '06' },
                    { value: 7, label: '07' },
                    { value: 8, label: '08' },
                    { value: 9, label: '09' },
                    { value: 10, label: '10' },
                    { value: 11, label: '11' },
                    { value: 12, label: '12' },
                    { value: 13, label: '13' },
                    { value: 14, label: '14' },
                    { value: 15, label: '15' },
                    { value: 16, label: '16' },
                    { value: 17, label: '17' },
                    { value: 18, label: '18' },
                    { value: 19, label: '19' },
                    { value: 20, label: '20' },
                    { value: 21, label: '21' },
                    { value: 22, label: '22' },
                    { value: 23, label: '23' },
                ]}
            />시 ~
                <Select
                    defaultValue={everyDayEndHour2}
                    style={{ width: 60 }}
                    onChange={everyDayEndHourChange2}
                    options={[
                        { value: 0, label: '00' },
                        { value: 1, label: '01' },
                        { value: 2, label: '02' },
                        { value: 3, label: '03' },
                        { value: 4, label: '04' },
                        { value: 5, label: '05' },
                        { value: 6, label: '06' },
                        { value: 7, label: '07' },
                        { value: 8, label: '08' },
                        { value: 9, label: '09' },
                        { value: 10, label: '10' },
                        { value: 11, label: '11' },
                        { value: 12, label: '12' },
                        { value: 13, label: '13' },
                        { value: 14, label: '14' },
                        { value: 15, label: '15' },
                        { value: 16, label: '16' },
                        { value: 17, label: '17' },
                        { value: 18, label: '18' },
                        { value: 19, label: '19' },
                        { value: 20, label: '20' },
                        { value: 21, label: '21' },
                        { value: 22, label: '22' },
                        { value: 23, label: '23' },
                        { value: 24, label: '24' },
                    ]}
                />시 까지<br/>
                <Select
                    defaultValue={everyHour}
                    value={everyHour}
                    style={{ width: 60 }}
                    onChange={everyHourChange}
                    options={[
                        { value: 1, label: '1' },
                        { value: 2, label: '2' },
                        { value: 3, label: '3' },
                        { value: 4, label: '4' },
                        { value: 5, label: '5' },
                        { value: 6, label: '6' },
                        { value: 7, label: '7' },
                        { value: 8, label: '8' },
                        { value: 9, label: '9' },
                        { value: 10, label: '10' },
                        { value: 11, label: '11' },
                        { value: 12, label: '12' },
                    ]}
                />시간 마다 실행
            </div>
        }
        {
            menuStr === "EveryDay" &&
            <div>
                매일 <Select
                defaultValue={everyDayHour}
                style={{ width: 60 }}
                onChange={everyDayHourChange}
                options={[
                    { value: 0, label: '00' },
                    { value: 1, label: '01' },
                    { value: 2, label: '02' },
                    { value: 3, label: '03' },
                    { value: 4, label: '04' },
                    { value: 5, label: '05' },
                    { value: 6, label: '06' },
                    { value: 7, label: '07' },
                    { value: 8, label: '08' },
                    { value: 9, label: '09' },
                    { value: 10, label: '10' },
                    { value: 11, label: '11' },
                    { value: 12, label: '12' },
                    { value: 13, label: '13' },
                    { value: 14, label: '14' },
                    { value: 15, label: '15' },
                    { value: 16, label: '16' },
                    { value: 17, label: '17' },
                    { value: 18, label: '18' },
                    { value: 19, label: '19' },
                    { value: 20, label: '20' },
                    { value: 21, label: '21' },
                    { value: 22, label: '22' },
                    { value: 23, label: '23' },
                ]}
            />시
                <Select
                    defaultValue={everyDayMin}
                    style={{ width: 60 }}
                    onChange={everyDayMinChange}
                    options={[
                        { value: 0, label: '00' },
                        { value: 1, label: '01' },
                        { value: 2, label: '02' },
                        { value: 3, label: '03' },
                        { value: 4, label: '04' },
                        { value: 5, label: '05' },
                        { value: 6, label: '06' },
                        { value: 7, label: '07' },
                        { value: 8, label: '08' },
                        { value: 9, label: '09' },
                        { value: 10, label: '10' },
                        { value: 11, label: '11' },
                        { value: 12, label: '12' },
                        { value: 13, label: '13' },
                        { value: 14, label: '14' },
                        { value: 15, label: '15' },
                        { value: 16, label: '16' },
                        { value: 17, label: '17' },
                        { value: 18, label: '18' },
                        { value: 19, label: '19' },
                        { value: 20, label: '20' },
                        { value: 21, label: '21' },
                        { value: 22, label: '22' },
                        { value: 23, label: '23' },
                        { value: 24, label: '24' },
                        { value: 25, label: '25' },
                        { value: 26, label: '26' },
                        { value: 27, label: '27' },
                        { value: 28, label: '28' },
                        { value: 29, label: '29' },
                        { value: 30, label: '30' },
                        { value: 31, label: '31' },
                        { value: 32, label: '32' },
                        { value: 33, label: '33' },
                        { value: 34, label: '34' },
                        { value: 35, label: '35' },
                        { value: 36, label: '36' },
                        { value: 37, label: '37' },
                        { value: 38, label: '38' },
                        { value: 39, label: '39' },
                        { value: 40, label: '40' },
                        { value: 41, label: '41' },
                        { value: 42, label: '42' },
                        { value: 43, label: '43' },
                        { value: 44, label: '44' },
                        { value: 45, label: '45' },
                        { value: 46, label: '46' },
                        { value: 47, label: '47' },
                        { value: 48, label: '48' },
                        { value: 49, label: '49' },
                        { value: 50, label: '50' },
                        { value: 51, label: '51' },
                        { value: 52, label: '52' },
                        { value: 53, label: '53' },
                        { value: 54, label: '54' },
                        { value: 55, label: '55' },
                        { value: 56, label: '56' },
                        { value: 57, label: '57' },
                        { value: 58, label: '58' },
                        { value: 59, label: '59' },
                    ]}
                /> 분 마다 실행
            </div>
        }
        {
            menuStr === "WeekDay" &&
            <div>
                평일 <Select
                defaultValue={weekDayHour}
                style={{ width: 60 }}
                onChange={weekDayHourChange}
                options={[
                    { value: 0, label: '00' },
                    { value: 1, label: '01' },
                    { value: 2, label: '02' },
                    { value: 3, label: '03' },
                    { value: 4, label: '04' },
                    { value: 5, label: '05' },
                    { value: 6, label: '06' },
                    { value: 7, label: '07' },
                    { value: 8, label: '08' },
                    { value: 9, label: '09' },
                    { value: 10, label: '10' },
                    { value: 11, label: '11' },
                    { value: 12, label: '12' },
                    { value: 13, label: '13' },
                    { value: 14, label: '14' },
                    { value: 15, label: '15' },
                    { value: 16, label: '16' },
                    { value: 17, label: '17' },
                    { value: 18, label: '18' },
                    { value: 19, label: '19' },
                    { value: 20, label: '20' },
                    { value: 21, label: '21' },
                    { value: 22, label: '22' },
                    { value: 23, label: '23' },
                ]}
            />시
                <Select
                    defaultValue={weekDayMin}
                    style={{ width: 60 }}
                    onChange={weekDayMinChange}
                    options={[
                        { value: 0, label: '00' },
                        { value: 1, label: '01' },
                        { value: 2, label: '02' },
                        { value: 3, label: '03' },
                        { value: 4, label: '04' },
                        { value: 5, label: '05' },
                        { value: 6, label: '06' },
                        { value: 7, label: '07' },
                        { value: 8, label: '08' },
                        { value: 9, label: '09' },
                        { value: 10, label: '10' },
                        { value: 11, label: '11' },
                        { value: 12, label: '12' },
                        { value: 13, label: '13' },
                        { value: 14, label: '14' },
                        { value: 15, label: '15' },
                        { value: 16, label: '16' },
                        { value: 17, label: '17' },
                        { value: 18, label: '18' },
                        { value: 19, label: '19' },
                        { value: 20, label: '20' },
                        { value: 21, label: '21' },
                        { value: 22, label: '22' },
                        { value: 23, label: '23' },
                        { value: 24, label: '24' },
                        { value: 25, label: '25' },
                        { value: 26, label: '26' },
                        { value: 27, label: '27' },
                        { value: 28, label: '28' },
                        { value: 29, label: '29' },
                        { value: 30, label: '30' },
                        { value: 31, label: '31' },
                        { value: 32, label: '32' },
                        { value: 33, label: '33' },
                        { value: 34, label: '34' },
                        { value: 35, label: '35' },
                        { value: 36, label: '36' },
                        { value: 37, label: '37' },
                        { value: 38, label: '38' },
                        { value: 39, label: '39' },
                        { value: 40, label: '40' },
                        { value: 41, label: '41' },
                        { value: 42, label: '42' },
                        { value: 43, label: '43' },
                        { value: 44, label: '44' },
                        { value: 45, label: '45' },
                        { value: 46, label: '46' },
                        { value: 47, label: '47' },
                        { value: 48, label: '48' },
                        { value: 49, label: '49' },
                        { value: 50, label: '50' },
                        { value: 51, label: '51' },
                        { value: 52, label: '52' },
                        { value: 53, label: '53' },
                        { value: 54, label: '54' },
                        { value: 55, label: '55' },
                        { value: 56, label: '56' },
                        { value: 57, label: '57' },
                        { value: 58, label: '58' },
                        { value: 59, label: '59' },
                    ]}
                /> 분 마다 실행
            </div>
        }
        {
            menuStr === "WeekEnd" &&
            <div>
                주말 <Select
                defaultValue={weekEndHour}
                style={{ width: 60 }}
                onChange={weekEndHourChange}
                options={[
                    { value: 0, label: '00' },
                    { value: 1, label: '01' },
                    { value: 2, label: '02' },
                    { value: 3, label: '03' },
                    { value: 4, label: '04' },
                    { value: 5, label: '05' },
                    { value: 6, label: '06' },
                    { value: 7, label: '07' },
                    { value: 8, label: '08' },
                    { value: 9, label: '09' },
                    { value: 10, label: '10' },
                    { value: 11, label: '11' },
                    { value: 12, label: '12' },
                    { value: 13, label: '13' },
                    { value: 14, label: '14' },
                    { value: 15, label: '15' },
                    { value: 16, label: '16' },
                    { value: 17, label: '17' },
                    { value: 18, label: '18' },
                    { value: 19, label: '19' },
                    { value: 20, label: '20' },
                    { value: 21, label: '21' },
                    { value: 22, label: '22' },
                    { value: 23, label: '23' },
                ]}
            />시
                <Select
                    defaultValue={weekEndMin}
                    style={{ width: 60 }}
                    onChange={weekEndMinChange}
                    options={[
                        { value: 0, label: '00' },
                        { value: 1, label: '01' },
                        { value: 2, label: '02' },
                        { value: 3, label: '03' },
                        { value: 4, label: '04' },
                        { value: 5, label: '05' },
                        { value: 6, label: '06' },
                        { value: 7, label: '07' },
                        { value: 8, label: '08' },
                        { value: 9, label: '09' },
                        { value: 10, label: '10' },
                        { value: 11, label: '11' },
                        { value: 12, label: '12' },
                        { value: 13, label: '13' },
                        { value: 14, label: '14' },
                        { value: 15, label: '15' },
                        { value: 16, label: '16' },
                        { value: 17, label: '17' },
                        { value: 18, label: '18' },
                        { value: 19, label: '19' },
                        { value: 20, label: '20' },
                        { value: 21, label: '21' },
                        { value: 22, label: '22' },
                        { value: 23, label: '23' },
                        { value: 24, label: '24' },
                        { value: 25, label: '25' },
                        { value: 26, label: '26' },
                        { value: 27, label: '27' },
                        { value: 28, label: '28' },
                        { value: 29, label: '29' },
                        { value: 30, label: '30' },
                        { value: 31, label: '31' },
                        { value: 32, label: '32' },
                        { value: 33, label: '33' },
                        { value: 34, label: '34' },
                        { value: 35, label: '35' },
                        { value: 36, label: '36' },
                        { value: 37, label: '37' },
                        { value: 38, label: '38' },
                        { value: 39, label: '39' },
                        { value: 40, label: '40' },
                        { value: 41, label: '41' },
                        { value: 42, label: '42' },
                        { value: 43, label: '43' },
                        { value: 44, label: '44' },
                        { value: 45, label: '45' },
                        { value: 46, label: '46' },
                        { value: 47, label: '47' },
                        { value: 48, label: '48' },
                        { value: 49, label: '49' },
                        { value: 50, label: '50' },
                        { value: 51, label: '51' },
                        { value: 52, label: '52' },
                        { value: 53, label: '53' },
                        { value: 54, label: '54' },
                        { value: 55, label: '55' },
                        { value: 56, label: '56' },
                        { value: 57, label: '57' },
                        { value: 58, label: '58' },
                        { value: 59, label: '59' },
                    ]}
                /> 분 마다 실행
            </div>
        }
        {
            menuStr === "DefineDay" &&
            <div>
                <Checkbox checked={monDay} onChange={onChangeMonday}>월요일</Checkbox>
                <Checkbox checked={tuesDay} onChange={onChangeTuesday}>화요일</Checkbox>
                <Checkbox checked={wednesDay} onChange={onChangeWednesday}>수요일</Checkbox>
                <Checkbox checked={thursday} onChange={onChangeThursday}>목요일</Checkbox>
                <Checkbox checked={friday} onChange={onChangeFriday}>금요일</Checkbox>
                <Checkbox checked={saturday} onChange={onChangeSaturday}>토요일</Checkbox>
                <Checkbox checked={sunday} onChange={onChangeSunDay}>일요일</Checkbox>

                <Select
                    defaultValue={defineDayHour}
                    style={{ width: 60 }}
                    onChange={defineDayHourChange}
                    options={[
                        { value: 0, label: '00' },
                        { value: 1, label: '01' },
                        { value: 2, label: '02' },
                        { value: 3, label: '03' },
                        { value: 4, label: '04' },
                        { value: 5, label: '05' },
                        { value: 6, label: '06' },
                        { value: 7, label: '07' },
                        { value: 8, label: '08' },
                        { value: 9, label: '09' },
                        { value: 10, label: '10' },
                        { value: 11, label: '11' },
                        { value: 12, label: '12' },
                        { value: 13, label: '13' },
                        { value: 14, label: '14' },
                        { value: 15, label: '15' },
                        { value: 16, label: '16' },
                        { value: 17, label: '17' },
                        { value: 18, label: '18' },
                        { value: 19, label: '19' },
                        { value: 20, label: '20' },
                        { value: 21, label: '21' },
                        { value: 22, label: '22' },
                        { value: 23, label: '23' },
                    ]}
                />시
                <Select
                    defaultValue={defineDayMin}
                    style={{ width: 60 }}
                    onChange={defineDayMinChange}
                    options={[
                        { value: 0, label: '00' },
                        { value: 1, label: '01' },
                        { value: 2, label: '02' },
                        { value: 3, label: '03' },
                        { value: 4, label: '04' },
                        { value: 5, label: '05' },
                        { value: 6, label: '06' },
                        { value: 7, label: '07' },
                        { value: 8, label: '08' },
                        { value: 9, label: '09' },
                        { value: 10, label: '10' },
                        { value: 11, label: '11' },
                        { value: 12, label: '12' },
                        { value: 13, label: '13' },
                        { value: 14, label: '14' },
                        { value: 15, label: '15' },
                        { value: 16, label: '16' },
                        { value: 17, label: '17' },
                        { value: 18, label: '18' },
                        { value: 19, label: '19' },
                        { value: 20, label: '20' },
                        { value: 21, label: '21' },
                        { value: 22, label: '22' },
                        { value: 23, label: '23' },
                        { value: 24, label: '24' },
                        { value: 25, label: '25' },
                        { value: 26, label: '26' },
                        { value: 27, label: '27' },
                        { value: 28, label: '28' },
                        { value: 29, label: '29' },
                        { value: 30, label: '30' },
                        { value: 31, label: '31' },
                        { value: 32, label: '32' },
                        { value: 33, label: '33' },
                        { value: 34, label: '34' },
                        { value: 35, label: '35' },
                        { value: 36, label: '36' },
                        { value: 37, label: '37' },
                        { value: 38, label: '38' },
                        { value: 39, label: '39' },
                        { value: 40, label: '40' },
                        { value: 41, label: '41' },
                        { value: 42, label: '42' },
                        { value: 43, label: '43' },
                        { value: 44, label: '44' },
                        { value: 45, label: '45' },
                        { value: 46, label: '46' },
                        { value: 47, label: '47' },
                        { value: 48, label: '48' },
                        { value: 49, label: '49' },
                        { value: 50, label: '50' },
                        { value: 51, label: '51' },
                        { value: 52, label: '52' },
                        { value: 53, label: '53' },
                        { value: 54, label: '54' },
                        { value: 55, label: '55' },
                        { value: 56, label: '56' },
                        { value: 57, label: '57' },
                        { value: 58, label: '58' },
                        { value: 59, label: '59' },
                    ]}
                /> 분 마다 실행
            </div>
        }
        </div>
    )

}
export default CronMaker;